import { CurrencyDollarIcon, SquaresFourIcon } from '@phosphor-icons/react';
import { IResource, Role } from '../types';

const LOGISTICS_ROLES: Array<Role> = [
  'RIDER',
  'WAREHOUSE_ADMIN',
  'WAREHOUSE_MANAGER',
  'WAREHOUSE_EXECUTIVE',
  'SUPER_ADMIN',
];

export const LOGISTICS_RESOURCES: Array<IResource> = [
  {
    name: 'dashboard',
    list: '/',
    meta: {
      label: 'Home',
      icon: <SquaresFourIcon />,
      masterRoles: LOGISTICS_ROLES,
    },
  },
  {
    name: 'packages',
    list: '/rides',
    show: '/rides/:packageId',
    meta: {
      label: 'Current rides',
      icon: <SquaresFourIcon />,
      masterRoles: LOGISTICS_ROLES,
    },
  },
  {
    name: 'returns',
    list: '/rides?currentTab=return',
    show: '/returns/:returnId',
    meta: {
      label: 'Returns',
      icon: <SquaresFourIcon />,
      masterRoles: LOGISTICS_ROLES,
    },
  },
  {
    name: 'cash-handover',
    list: '/cash-handover',
    meta: {
      label: 'Cash handover',
      icon: <CurrencyDollarIcon />,
      masterRoles: LOGISTICS_ROLES,
    },
  },
  {
    name: 'facilities',
    meta: {
      hide: true,
      masterRoles: LOGISTICS_ROLES,
    },
  },
];
